import { Component, input } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-validation-message',
  standalone: true,
  imports: [TranslatePipe],
  template: `
    @if (visible()) {
      <p class="field__error" role="alert">
        @switch (errorKey()) {
          @case ('required') {
            {{ 'COMMON.VALIDATION.REQUIRED' | translate }}
          }
          @case ('email') {
            {{ 'COMMON.VALIDATION.EMAIL' | translate }}
          }
          @case ('minlength') {
            {{ 'COMMON.VALIDATION.MIN_LENGTH' | translate: { min: errorValue()?.['requiredLength'] } }}
          }
          @case ('maxlength') {
            {{ 'COMMON.VALIDATION.MAX_LENGTH' | translate: { max: errorValue()?.['requiredLength'] } }}
          }
          @case ('min') {
            {{ 'COMMON.VALIDATION.MIN' | translate: { min: errorValue()?.['min'] } }}
          }
          @case ('max') {
            {{ 'COMMON.VALIDATION.MAX' | translate: { max: errorValue()?.['max'] } }}
          }
          @case ('futureDate') {
            {{ 'COMMON.VALIDATION.FUTURE_DATE' | translate }}
          }
          @case ('pastDate') {
            {{ 'COMMON.VALIDATION.PAST_DATE' | translate }}
          }
          @case ('invalidDate') {
            {{ 'COMMON.VALIDATION.DATE' | translate }}
          }
          @case ('arabicTitle') {
            {{ 'COMMON.VALIDATION.ARABIC_ONLY' | translate }}
          }
          @case ('englishTitle') {
            {{ 'COMMON.VALIDATION.ENGLISH_ONLY' | translate }}
          }
          @case ('pattern') {
            {{ patternMessageKey() | translate }}
          }
          @default {
            {{ 'COMMON.VALIDATION.INVALID' | translate }}
          }
        }
      </p>
    }
  `,
  styles: [
    `
      .field__error {
        margin: 0.35rem 0 0;
        font-size: var(--wn-form-error-text-size, 0.82rem);
        font-weight: 700;
        line-height: 1.4;
        color: var(--wn-accent, #b42318);
      }
    `,
  ],
})
export class ValidationMessage {
  readonly control = input<AbstractControl | null | undefined>(null);
  readonly patternMessageKey = input('COMMON.VALIDATION.PATTERN');
  readonly submitted = input(false);

  protected visible(): boolean {
    const control = this.control();
    return Boolean(control?.invalid && (this.submitted() || control.touched || control.dirty));
  }

  protected errorKey(): string | null {
    const errors = this.control()?.errors;
    return errors ? Object.keys(errors)[0] : null;
  }

  protected errorValue(): Record<string, unknown> | null {
    const key = this.errorKey();
    const value = key ? this.control()?.errors?.[key] : null;
    return value && typeof value === 'object' ? (value as Record<string, unknown>) : null;
  }
}
